import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Router } from "@angular/router";
import { TranslocoPipe } from "@ngneat/transloco";
import { PermissionsService } from "app/core/auth/services";
import { ROUTES_CONSTANT } from "app/core/constants";
import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  exportAs: "user",
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule, TranslocoPipe],
})
export class UserComponent {
  private _keycloakService = inject(KeycloakService);
  private _permissionsService = inject(PermissionsService);
  private _router = inject(Router);

  showAvatar = false;

  get isLoggedIn(): boolean {
    return this._keycloakService.isLoggedIn();
  }

  // preferred_username/email solo para mostrar; sub sigue siendo la identidad canónica.
  get username(): string | undefined {
    return this._permissionsService.username;
  }

  get email(): string | undefined {
    return this._permissionsService.email;
  }

  signIn(): void {
    this._keycloakService.login({ redirectUri: window.location.href });
  }

  signOut(): void {
    this._router.navigate([ROUTES_CONSTANT.authLogout.absolutePath]);
  }
}
